import React, { useEffect, useRef, useState } from 'react';
import { Ripple as ButtonRipple } from 'react-ripple-click';

// Hidden dialogs must discard animations before they can be shown again.
export function Ripple() {
  const marker = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const button = marker.current?.closest('button, a');
    if (!button) return;
    const win = button.ownerDocument.defaultView;
    let frame;
    const update = () => {
      win.cancelAnimationFrame(frame);
      frame = win.requestAnimationFrame(() => {
        let shown = button.getClientRects().length > 0;
        for (let node = button; shown && node; node = node.parentElement) {
          const style = win.getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') shown = false;
        }
        setVisible(shown);
      });
    };
    const observer = new win.MutationObserver(update);
    for (let node = button; node; node = node.parentElement) {
      observer.observe(node, { attributes: true, attributeFilter: ['class', 'style', 'role', 'hidden', 'aria-hidden'] });
    }
    update();
    return () => { observer.disconnect(); win.cancelAnimationFrame(frame); };
  }, []);
  return <><span ref={marker} hidden />{visible && <ButtonRipple />}</>;
}
